'use client'

import { useModals, usePrinter, useSelectedCustomer } from '@/lib/hooks'
import { cn } from '@/lib/utils'
import { Mail, MessageCircle, Printer } from 'lucide-react'
import React from 'react'
import { toast } from 'sonner'

import { Button, Receipt, ScrollArea } from '@/components/ui'

export const PrintReceipt = ({
  printerType,
  receipt,
}: {
  printerType: string | null
  receipt: any
}) => {
  const { openModal } = useModals()
  const { requestPrinter, printer, printReceipt } = usePrinter()
  const { customer } = useSelectedCustomer()
  const smsReceipt = localStorage?.getItem('smsReceipt') === 'on'
  const emailReceipt = localStorage?.getItem('emailReceipt') === 'on'

  const printNow = React.useCallback(async () => {
    await printReceipt(receipt)
  }, [printReceipt, receipt])

  console.log({ receipt })

  // React.useEffect(() => {
  //   if (receipt && printerType !== null && !hasOpenedReceipt.current) {
  //     hasOpenedReceipt.current = true
  //     if (printerType !== 'thermal') {
  //       if (!receipt?.url) {
  //         toast.error('Could not find receipt URL')
  //         return
  //       }

  //       window.open(receipt?.url, '_blank')
  //     } else {
  //       printNow()
  //     }
  //   }
  // }, [receipt, printerType, printNow])

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col gap-8">
        <ScrollArea className="max-h-[500px] rounded-lg border border-gray-100 p-4 print:h-auto">
          <Receipt data={receipt} />
        </ScrollArea>

        <div className="flex w-full flex-col gap-2 print:hidden">
          {!printer && printerType === 'thermal' && (
            <Button size="lg" className="w-full" onClick={requestPrinter}>
              Connect Printer
            </Button>
          )}

          <div className="flex w-full items-center gap-2">
            {printerType !== 'thermal' && (
              <Button
                size="lg"
                className="w-full"
                onClick={() => {
                  if (!receipt?.url) {
                    toast.error('Could not find receipt URL')
                    return
                  }

                  window.open(receipt?.url, '_blank')
                }}
              >
                <Printer className="size-4" />
                Print Receipt
              </Button>
            )}

            {printer && printerType === 'thermal' && (
              <Button
                size="lg"
                className="w-full"
                onClick={printNow}
                disabled={!printer}
              >
                <Printer className="size-4" />
                Print Receipt
              </Button>
            )}

            <Button
              size="lg"
              className={cn('w-full', !emailReceipt && 'opacity-50')}
              onClick={() => {
                if (!emailReceipt) {
                  toast.error('Email receipt is not enabled')
                  return
                }
                openModal('EMAIL_RECEIPT')
              }}
            >
              <div className="flex flex-col">
                <div className="flex items-center gap-2">
                  <Mail className="size-4" />
                  Email Receipt
                </div>
                <span className="text-xs text-gray-300">{customer?.email}</span>
              </div>
            </Button>

            <Button
              size="lg"
              className={cn('w-full', !smsReceipt && 'opacity-50')}
              onClick={() => {
                if (!smsReceipt) {
                  toast.error('SMS receipt is not enabled')
                  return
                }

                openModal('SMS_RECEIPT')
              }}
            >
              <div className="flex flex-col">
                <div className="flex items-center gap-2">
                  <MessageCircle className="size-4" />
                  SMS Receipt
                </div>
                <span className="text-xs text-gray-300">{customer?.phone}</span>
              </div>
            </Button>
          </div>

          {/* <Button
            size="lg"
            variant="secondary"
            className="w-full"
            onClick={() => {
              closeModal('PRINT_RECEIPT')
            }}
          >
            Close
          </Button> */}
        </div>
      </div>
    </div>
  )
}
